export const environment = {
  coreApiEndpoint: 'https://core.dialogshift.com',
  ibeApiEndpoint: 'https://helper.dialogshift.com',
  iframeHost: 'https://webchat.dialogshift.com',
}
